var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.theme.components.BaseElementLayout, {
    tag: "component",
    attrs: {
      "el$": _vm.el$
    }
  }, [_c('template', {
    slot: "field"
  }, [_vm._t("prefix"), _vm.floating ? _c(_vm.theme.components.ElementLabelFloating, {
    tag: "component",
    attrs: {
      "visible": !_vm.empty
    }
  }, [_vm._v(_vm._s(_vm.floating))]) : _vm._e(), _vm.placeholder && !(this.multiple && this.native) ? _c('span', {
    class: _vm.theme.classes.selectNativePlaceholder
  }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e(), _vm.isNative ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.model,
      expression: "model"
    }],
    ref: "select$",
    class: _vm.theme.classes.select,
    attrs: {
      "name": _vm.name,
      "id": _vm.id,
      "multiple": _vm.multiple,
      "disabled": _vm.disabled
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.model = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }, _vm.handleChange]
    }
  }, _vm._l(_vm.selectOptions, function (option, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": option['value']
      }
    }, [_vm._v("\n        " + _vm._s(option['label']) + "\n      ")]);
  }), 0) : _c('multiselect', _vm._b({
    ref: "select$",
    attrs: {
      "id": _vm.id,
      "name": _vm.name.toString(),
      "options": _vm.selectOptions,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "multiple": _vm.multiple,
      "searchable": _vm.search,
      "taggable": _vm.taggable,
      "tagPlaceholder": _vm.tagPlaceholder,
      "label": 'label',
      "track-by": _vm.trackBy,
      "loading": _vm.loading,
      "optionsLimit": _vm.limit
    },
    on: {
      "input": _vm.handleInput,
      "select": _vm.handleSelect,
      "remove": _vm.handleRemove,
      "search-change": _vm.handleSearchChange,
      "tag": _vm.handleTag,
      "open": _vm.handleOpen,
      "close": _vm.handleClose
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(_ref) {
        var option = _ref.option,
          search = _ref.search;
        return _vm._t("option", function () {
          return [_vm.slots.option ? _c(_vm.slots.option, {
            tag: "component",
            attrs: {
              "el$": _vm.el$,
              "option": option,
              "search": search
            }
          }) : _vm._e()];
        }, {
          "el$": _vm.el$,
          "option": option,
          "search": search
        });
      }
    }, {
      key: "selection",
      fn: function fn(_ref2) {
        var values = _ref2.values,
          search = _ref2.search,
          remove = _ref2.remove;
        return _vm._t("selection", function () {
          return [_vm.slots.selection ? _c(_vm.slots.selection, {
            tag: "component",
            attrs: {
              "el$": _vm.el$,
              "values": values,
              "search": search,
              "remove": remove
            },
            scopedSlots: _vm._u([{
              key: "tag",
              fn: function fn(_ref3) {
                var option = _ref3.option,
                  search = _ref3.search,
                  remove = _ref3.remove;
                return _vm._t("tag", function () {
                  return [_vm.slots.tag && _vm.selectOptions.length > 0 ? _c(_vm.slots.tag, {
                    tag: "component",
                    attrs: {
                      "el$": _vm.el$,
                      "option": option,
                      "search": search,
                      "remove": remove
                    }
                  }) : _vm._e()];
                }, {
                  "el$": _vm.el$,
                  "option": option,
                  "search": search,
                  "remove": remove
                });
              }
            }], null, true)
          }) : _vm._e()];
        }, {
          "el$": _vm.el$,
          "values": values,
          "search": search,
          "remove": remove
        });
      }
    }], null, true),
    model: {
      value: _vm.model,
      callback: function callback($$v) {
        _vm.model = $$v;
      },
      expression: "model"
    }
  }, 'multiselect', _vm.options, false), [_vm._t("beforeList", function () {
    return [_vm.slots.beforeList ? _c(_vm.slots.beforeList, {
      tag: "component",
      attrs: {
        "el$": _vm.el$
      }
    }) : _vm._e()];
  }, {
    "slot": "beforeList",
    "el$": _vm.el$
  }), _vm._t("afterList", function () {
    return [_vm.slots.afterList ? _c(_vm.slots.afterList, {
      tag: "component",
      attrs: {
        "el$": _vm.el$
      }
    }) : _vm._e()];
  }, {
    "slot": "afterList",
    "el$": _vm.el$
  }), _vm._t("singleLabel", function () {
    return [_vm.slots.singleLabel ? _c(_vm.slots.singleLabel, {
      tag: "component",
      attrs: {
        "el$": _vm.el$,
        "option": _vm.selectedOption
      }
    }) : _vm._e()];
  }, {
    "slot": "singleLabel",
    "el$": _vm.el$,
    "option": _vm.selectedOption
  }), _vm._t("noResult", function () {
    return [_vm.slots.noResult ? _c(_vm.slots.noResult, {
      tag: "component",
      attrs: {
        "el$": _vm.el$
      }
    }) : _vm._e()];
  }, {
    "slot": "noResult",
    "el$": _vm.el$
  }), _vm._t("noOptions", function () {
    return [_vm.slots.noOptions ? _c(_vm.slots.noOptions, {
      tag: "component",
      attrs: {
        "el$": _vm.el$
      }
    }) : _vm._e()];
  }, {
    "slot": "noOptions",
    "el$": _vm.el$
  })], 2), _vm._t("suffix")], 2), _vm._t("label", null, {
    "slot": "label",
    "el$": _vm.el$
  }), _vm._t("before", null, {
    "slot": "before",
    "el$": _vm.el$
  }), _vm._t("between", null, {
    "slot": "between",
    "el$": _vm.el$
  }), _vm._t("error", null, {
    "slot": "error",
    "el$": _vm.el$
  }), _vm._t("after", null, {
    "slot": "after",
    "el$": _vm.el$
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }